module.exports = {
      id: "android-block-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#android-block",
      toString: function () {
        return this.url;
      }
    }